import React from "react"

import BackgroundImage from "gatsby-background-image"
import { useStaticQuery, graphql } from "gatsby"

import { Container } from "./styled"

export default function Banner(props) {
  const { bannerimage01 } = useStaticQuery(graphql`
    query {
      bannerimage01: file(relativePath: { eq: "bannerimage01.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1200, maxHeight: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <>
      <Container>
        <BackgroundImage
          className="masthead"
          fluid={bannerimage01.childImageSharp.fluid}
          fadeIn
        >
         <div className="black-overlay">
            <div className="content-box">
              <h2>Humberto Vasconcelos Faustino Porto</h2>
              <p>OAB/Go 54.075</p>
              <h2>William Santos Vieira</h2>
              <p>OAB/Go 73.290</p>
            </div>
          </div>
        </BackgroundImage>
      </Container>
    </>
  )
}
